import { AWARE_CONFIG } from '../consts/aware';

export type AwareParams = {
  method?: string | null;
  encodedReturnUrl?: string | null;
};

export const decodeReturnUrl = (
  encoded?: string | null,
): string | undefined => {
  if (!encoded) {
    return undefined;
  }

  try {
    const decodedOnce = atob(encoded);
    const decoded = decodeURIComponent(decodedOnce);

    new URL(decoded, window.location.origin);

    return decoded;
    // eslint-disable-next-line
  } catch (e1) {
    try {
      const plain = decodeURIComponent(encoded);
      const isAbsoluteHttp =
        plain.startsWith('http://') || plain.startsWith('https://');
      const isRootRelative = plain.startsWith('/');

      if (!isAbsoluteHttp && !isRootRelative) {
        return undefined;
      }

      new URL(plain, window.location.origin);

      return plain;

      // eslint-disable-next-line
    } catch (e2) {
      return undefined;
    }
  }
};

export const extractStateFromReturnUrl = (
  decodedReturnUrl?: string,
): string | undefined => {
  try {
    if (!decodedReturnUrl) {
      return undefined;
    }

    const url = new URL(decodedReturnUrl);
    const state = url.searchParams.get('state');

    return state || undefined;
  } catch {
    return undefined;
  }
};

export const buildAwareSuccessRedirect =
  (args: { returnURL?: string; apiKey?: string }) => () => {
    const { returnURL, apiKey } = args;

    if (!apiKey || !returnURL) return;

    try {
      const redirectUrl = new URL(returnURL);

      redirectUrl.searchParams.append(AWARE_CONFIG.URL_PARAM_API_KEY, apiKey);
      window.location.href = redirectUrl.toString();
    } catch (error) {
      console.error('Invalid return URL:', returnURL, error);
    }
  };
